/* eslint-disable @typescript-eslint/no-redeclare */
export const HttpParamType = {
  HEADER: 'HEADER',
  QUERY_PARAM: 'QUERY_PARAM',
  PATH_PARAM: 'PATH_PARAM',
} as const;

export type HttpParamType = (typeof HttpParamType)[keyof typeof HttpParamType];
